import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { LanguageCode } from '@/src/types/common';

const isDev = process.env.REACT_APP_ENV_MODE === 'dev';

interface StoreState {
  lang: LanguageCode;
}

interface StoreActions {
  setLang: (lang: LanguageCode) => void;
}

const initialState: StoreState = {
  lang: 'ko',
};

const useLangStore = create<StoreState & StoreActions>()(
  devtools(
    set => ({
      ...initialState,
      setLang: (lang: LanguageCode) => set({ lang }),
    }),
    { name: 'LangStore', enabled: isDev },
  ),
);

export default useLangStore;
